import PauseIcon from '@components/icons/Pause.svg';
import PlayIcon from '@components/icons/Play.svg';
import { useEffect, useRef, useState } from 'react';
import { usePageContext } from '../../../../../../providers/PageProvider';
import { AdminJobTopActionButton } from '@components/core-ui/form-elements/buttons/Button/variations/AdminJobTopActionButton';

export const LiveUpdatePageButton = () => {
  const { job, manualRefreshJobData } = usePageContext();
  const [isLiveUpdatePage, setIsLiveUpdatePage] = useState(false);
  const intervalRef = useRef<number | null>(null);

  useEffect(() => {
    if (isLiveUpdatePage) {
      if (intervalRef.current === null) {
        intervalRef.current = window.setInterval(() => {
          manualRefreshJobData();
        }, 10000);
      }
    } else {
      if (intervalRef.current !== null) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    }

    return () => {
      if (intervalRef.current !== null) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [isLiveUpdatePage, manualRefreshJobData]);

  if (!job) {
    return null;
  }

  return (
    <AdminJobTopActionButton
      title="Live update page"
      className="min-w-[140px]"
      onClick={() => setIsLiveUpdatePage((prev) => !prev)}
    >
      {isLiveUpdatePage ? <PauseIcon /> : <PlayIcon />}
      Live update page
    </AdminJobTopActionButton>
  );
};
